export default __webpack_public_path__ + "static/media/doc-icon.21ecfe13.svg";